import { inquiryFormLoader } from '../../rankers/inquiry/components/inquiry_form/inquiry_form_loader';
inquiryFormLoader();

// Be aware that if this inquiry pack is injected into the page more than once (as it often is) then this event will fire multiple times.
document.dispatchEvent( new Event('RankersInquiryLoaded') );
